// Custom CWS JS File - Part of Turbo v9 Upgrade, Nov 2023 by Matt
// ===============================================================
// On DOMLoaded, Hide Purchase Details if CWS QuoteBox is rendered
 document.addEventListener('DOMContentLoaded', () => {
  const quoteForm = document.querySelector('.shopify-block .qmp_container .qmp_form_container')
  const purchaseOptionsContainer = document.querySelector('.purchase-details')

  if (quoteForm) {
    purchaseOptionsContainer.style.display = "none"
  }
});


tabs = document.querySelectorAll('.custom-tab');
tabContents = document.querySelectorAll('.custom__tab-content');

tabs.forEach(function(tab){
    tab.addEventListener('click',function(){

        contentId = this.dataset.contentId;
        content = document.getElementById(contentId);

        tabContents.forEach(function(content){
            content.classList.remove('active');
        });

        tabs.forEach(function(tab){
            tab.classList.remove('active');
        });

        this.classList.add('active');
        content.classList.add('active');
    });
});


